import { theme } from '@app/legacy/old_core/styles';

const { breakpoints } = theme;

export const isWindowSizeLessThanBreakpoint = (breakpoint: keyof typeof breakpoints) => {
  const windowWidth = document.documentElement.clientWidth;

  return windowWidth < breakpoints[breakpoint];
};
